<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Promo2019_Events from './Promo2019_Events.vue'

  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsPromo2019_Events = Promo2019_Events.data().items

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-06-19',
        major: [],
        excepts: [],
        items: [


          // [NOTE] クラス認定会
          // ================================================================================

          externalItem(itemsPromo2019_Events, 'P-039', { collection: 'ClassRecognition' }),
          item({ collection: 'ClassRecognition', rare: 'SR' }),
          item({ collection: 'ClassRecognition', rare: 'SR' }),
          item({ collection: 'ClassRecognition', rare: 'SR' }),


          externalItem(itemsPromo2019_Events, 'P-103', { collection: 'ClassRecognition' }),
          externalItem(itemsPromo2019_Events, 'P-104', { collection: 'ClassRecognition' }),
          externalItem(itemsPromo2019_Events, 'P-105', { collection: 'ClassRecognition' }),
          item({ collection: 'ClassRecognition', rare: 'KR' }),


          // 2019年の認定会で配布されたのはプロモニコチケ。 (P-NC-002)
          // 2021年オルフレ弾の認定会で入手できるのは、バラのプリチケ。
          item({
            collection  : 'ClassRecognition',
            id          : 'P-173',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとワンピ',
            imgUrl      : '/images/items/P-NC-002-O.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 1570,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ClassRecognition',
            id          : 'P-174',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとシューズ',
            imgUrl      : '/images/items/P-NC-002-S.png',
            kind        : 'シューズ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ClassRecognition',
            id          : 'P-175',
            rare        : 'KR',
            name        : 'ピュアプリンセスプラチナキラッとヘアアクセ',
            imgUrl      : '/images/items/P-NC-002-H.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({ collection: 'ClassRecognition', rare: 'KR' }),


          // [NOTE] クラス認定会 パシャッとアイテム
          // ================================================================================

          item({
            collection  : 'ClassRecognition',
            id          : 'PAF01-115',
            rare        : 'PR',
            name        : 'モードバルーン',
            imgUrl      : '/images/items/PAF01-115.png',
            kind        : 'パシャッとアイテム',
            color       : '黒',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ClassRecognition',
            id          : 'PAF01-116',
            rare        : 'PR',
            name        : 'ロリータライトブルーパラソル',
            imgUrl      : '/images/items/PAF01-116.png',
            kind        : 'パシャッとアイテム',
            color       : '水',
            brand       : 'DW',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ClassRecognition',
            id          : 'PAF01-117',
            rare        : 'PR',
            name        : 'ジュエルパクトホワイト',
            imgUrl      : '/images/items/PAF01-117.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'MR',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ClassRecognition',
            rare        : 'PR',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : 'ClassRecognition',
            id          : 'PAF01-118',
            rare        : 'PR',
            name        : 'プリたまGOノーブルホワイト',
            imgUrl      : '/images/items/PAF01-118.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'ClassRecognition',
            id          : 'PAF01-119',
            rare        : 'PR',
            name        : 'クリスタルクイーンズロッド',
            imgUrl      : '/images/items/PAF01-119.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'LP',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'ClassRecognition',
            rare        : 'PR',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'ClassRecognition',
            rare        : 'PR',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] TBD
          // ================================================================================



          // [NOTE] TBD
          // ================================================================================



        ]
      }
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="クラス認定会" color="#00c7da" :items="collection('ClassRecognition', 'SR')" />
      <ItemList title=""             color="#ff5d91" :items="collection('ClassRecognition', 'KR')" />
      <ItemList title=""             color="#ffa1bc" :items="collection('ClassRecognition', 'PR')" />
    </template>

    <template #col2>
    </template>

    <template #col3>
    </template>

    <template #col4>
    </template>

    <template #col5>
      <Status :date="date" :items="items" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    // right: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
